import { gql } from '@apollo/client';

const SERVICE_FIELDS = gql`
  fragment ServiceFields on Service {
    id
    code
    name
    description
    category_id
    tax_rate_id
    price_cents
    is_quick_key
    branch_id
    status
    created_at
    updated_at
  }
`;

export const SERVICES_QUERY = gql`
  ${SERVICE_FIELDS}
  query Services(
    $offset: Int
    $limit: Int
    $search: String
    $status_filter: CatalogStatusFilter
    $category_id: ID
    $quick_key_only: Boolean
  ) {
    services(
      offset: $offset
      limit: $limit
      search: $search
      status_filter: $status_filter
      category_id: $category_id
      quick_key_only: $quick_key_only
    ) {
      items {
        ...ServiceFields
      }
      page {
        total
        offset
        limit
        has_more
      }
    }
  }
`;

export const SET_SERVICE_STATUS_MUTATION = gql`
  ${SERVICE_FIELDS}
  mutation SetServiceStatus($id: ID!, $status: String!) {
    setServiceStatus(id: $id, status: $status) {
      ...ServiceFields
    }
  }
`;

export const CREATE_SERVICE_MUTATION = gql`
  ${SERVICE_FIELDS}
  mutation CreateService($input: CreateServiceInput!) {
    createService(input: $input) {
      ...ServiceFields
    }
  }
`;
